import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Config from '../../config';
import Form from '../../view/form';
import TypeGroup from '../../model/type.group';
import TypeGroups from '../../collection/type.groups';

import { roleA, roleAC, roleC, roleAI } from  '../../roles';
import { ask, } from '../../utils/popups';
import { restrict } from '../../model/actions';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/type.groups.list',

    url() {
        return 'types/groups';
    },

    open() {
        const form = new Form( {
            template: 'module/refbooks/type.groups.form',
            clusters: this.options.clusters,
        } );

        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: restrict( roleAC,

                () => {
                    const current = new TypeGroup();
                    const binding = form.bind( current );
                    binding.then( () => {
                        if (this.state().cluster && this.state().cluster.id != -1)
                            current.set( 'cluster', this.state().cluster );
                        else if (~roleC.indexOf( Config.role() ))
                            current.set( 'cluster', Config.cluster() );
                    } );
        
                    ask( binding,
                        'type::modal new type group - title', 'actions::create', 'actions::cancel', 
                        () => this.options.typeGroups.save( form ) )
                            .then( () => this.options.source.reset(
                                this.options.typeGroups.models,
                                { silent: true } // a sort of paranoia
                            ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                } ),
            
            edit: restrict( roleAC,

                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" type groups: with cluster == my cluster;
                    // there are only global and "my" type groups in the list;
                    // so, let's check only presence of cluster in type group
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },

                current => {
                    current = current.clone();
                    ask( form.bind( current ),
                        'type::modal edit type group - title', 'actions::save', 'actions::close', 
                        () => this.options.source.save( form ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                } ),
            
            destroy: restrict( roleAC,

                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" type groups: with cluster == my cluster;
                    // there are only global and "my" type groups in the list;
                    // so, let's check only presence of cluster in type group
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },

                current => this.destroy( current, 
                    'type::modal delete type group - title', 
                    'type::modal delete type group - confirmation text' ) ),
                    
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new TypeGroups( this.options.typeGroups.models );
        this.options.sorted = new TypeGroups();
        this.options.filtered = new TypeGroups();
        this.options.paged = new TypeGroups( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/type.groups.list.js